/** imID verification result codes returned by BioWebBack (message body on 422). */
const IMID_API_ERROR_CODES = new Set(['2000', '2001', '2002', '2003', '9999']);

/**
 * Maps an axios-style API error from imID endpoints to a result code for navigation.
 * Falls back to connection lost when the backend did not return a known imID code.
 */
export function getImIdErrorCodeFromApiError(
    error: unknown,
    fallback = '2003'
): string {
    const message = (error as { response?: { data?: { message?: unknown } } })
        ?.response?.data?.message;
    if (typeof message === 'string' && IMID_API_ERROR_CODES.has(message)) {
        return message;
    }
    return fallback;
}
